import { Grid, TextField } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { getSpecUrl, isEmpty, isNotEmpty } from '../../common/util.services';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import { MATERIAL_SPECS_MAP, SpecListItem } from '../../master-data/specs/specs.mapping';
import INumberField from '../../../components/text-component/numberfield/i-numberfield.component';
import { findMasterDataBySku } from '../../master-data/masterdata.services';

const ProductDetailComponent = (props: any) => {
  const [description, setDescription] = useState(props.data.description);
  const prdType = props.data.product.includes('Fabric') ? 'Fabric' : 'Made-up';
  const [prdData, setPrdData] = useState(props.data);
  const appContext = useContext(AppContext);

  useEffect(() => {
    if(isEmpty(props.data.tenantId) && isNotEmpty(props.data.sku) && 'NA' !== props.data.sku) {
      findMasterDataBySku(props.data.sku, appContext,
        (response: any) => {
          response.data.isAmazon = props.data.isAmazon;
          setPrdData(response.data);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
        });
      }
  }, []);

  const onSubmit = (data: any) => {
    if(isEmpty(description)) {
      appContext.setDialogMessage('Enter product description.');
      return;
    }

    props.data.description = description;
    props.data.spec1 = data.spec1;
    props.data.spec2 = data.spec2;
    props.data.spec3 = data.spec3;
    props.data.spec4 = data.spec4;
    props.data.spec5 = data.spec5;
    props.data.spec6 = data.spec6;
    props.data.spec7 = data.spec7;
    props.data.spec8 = data.spec8;
    props.data.spec9 = data.spec9;
    props.data.spec10 = data.spec10;
    props.data.spec11 = data.spec11;
    props.data.spec12 = data.spec12;
    props.data.spec13 = data.spec13;
    props.data.spec14 = data.spec14;
    props.data.spec15 = data.spec15;
    if('Made-up' === prdType) {
      props.data.pack = data.spec4;
    }
    props.data.sku = data.sku;
    
    props.close();
  }

  const onCancel = () => {
    props.close();
  }

  function isEditable(spec: any) {
    return (prdData.isAmazon && ('spec1' === spec.fieldObject || 'spec2' === spec.fieldObject || 
                                 'spec3' === spec.fieldObject || 'spec4' === spec.fieldObject)) || 
           (prdType === 'Made-up' && 'spec1' === spec.fieldObject) || !prdData.isEditable
  }

  const getMainComponent = () => {
    return <Grid container spacing={1} width={700}>
      {MATERIAL_SPECS_MAP[prdType].map((spec: SpecListItem) => {
        return <Grid xs={3}>
          {spec.type === "select" ? <IDropdown name={spec.fieldObject} label={spec.fieldName} url={getSpecUrl(prdType, spec)} 
            itemList={spec.items.sort()} required={true} disabled={isEditable(spec)}/> :
            spec.type === 'number' ? <INumberField name={spec.fieldObject} label={spec.fieldName} 
                                      required={true} disabled={isEditable(spec)}/> :
          <ITextField name={spec.fieldObject} label={spec.fieldName} required={true} disabled={isEditable(spec)} />}
        </Grid>
      })}
      <Grid xs={3}>
          <ITextField name='sku' label={'SKU'} required={false} disabled={prdData.isAmazon}/>
      </Grid>
      <Grid xs={12}>
          <TextField name='description' label={'Description'} multiline={true} fullWidth={true} type='string'
              margin='dense' inputProps={{ style: { height: "50px"}}} required={true}
              variant="outlined" rows={5} value={description} onChange={(e: any) => {setDescription(e.target.value)}}/>
      </Grid>
      </Grid>
  }

  return  <IForm formData={prdData} title={''} submitForm={onSubmit} mainComponent={getMainComponent()}
            showSaveBtn={isEmpty(props.readOnly) || !props.readOnly}
            showCancelBtn={isEmpty(props.readOnly) || !props.readOnly}
            cancelNavigation={false} cancelForm={onCancel}></IForm>
}

export default ProductDetailComponent;